import React from 'react';
import { Icon } from '@chakra-ui/react';
import {
  LuTally1,
  LuTally2,
  LuTally3,
  LuTally4,
  LuTally5,
} from 'react-icons/lu';

const TallyMarks = ({ used, total }) => {
  const getTallyIcon = count => {
    switch (count) {
      case 1:
        return LuTally1;
      case 2:
        return LuTally2;
      case 3:
        return LuTally3;
      case 4:
        return LuTally4;
      case 5:
        return LuTally5;
      default:
        return LuTally1;
    }
  };

  const usedTallyIcon = getTallyIcon(total - used);
  const totalTallyIcon = getTallyIcon(total);

  return (
    <div style={{ position: 'relative', width: '2rem', height: '2rem' }}>
      <Icon
        as={totalTallyIcon}
        color="black"
        fontSize="2rem"
        position="absolute"
        top="0"
        left="0"
        zIndex={0}
        sx={{
          strokeWidth: '3px',
          stroke: 'black',
        }}
      />
      <Icon
        as={totalTallyIcon}
        color="black"
        fontSize="2rem"
        position="absolute"
        top="0"
        left="0"
        zIndex={1}
        sx={{
          strokeWidth: '2px',
          stroke: 'white',
        }}
      />
      <Icon
        as={usedTallyIcon}
        color="black"
        fontSize="2rem"
        position="absolute"
        top="0"
        left="0"
        zIndex={2}
        sx={{
          strokeWidth: '2px',
          stroke: total - used === 0 ? 'white' : 'black',
        }}
      />
    </div>
  );
};
export default TallyMarks;
